import type { Configuration } from "@bloomreach/discovery-web-sdk";
import type { BloomreachConfig, SortOption } from "./types";

export const SORT_OPTIONS: SortOption[] = [
  { label: "Relevance", value: "" },
  { label: "Popular", value: "best_seller desc" },
  { label: "Newest", value: "release_date desc" },
  { label: "Name (A-Z)", value: "title asc" },
  { label: "Name (Z-A)", value: "title desc" },
  { label: "Price (low - high)", value: "price_min asc" },
  { label: "Price (high - low)", value: "price_min desc" },
];

export const BLOOMREACH_DEFAULT_ROWS = 48;

export const BLOOMREACH_STALE_TIME_MS = 5 * 60 * 1000;

export const BLOOMREACH_DEFAULT_FL = [
  "pid",
  "title",
  "handle",
  "price",
  "sale_price",
  "price_range",
  "sale_price_range",
  "compare_at_price",
  "thumb_image",
  "url",
  "review_rating",
  "review_count",
  "stock_status_summary",
  "has_alternative_products",
  "has_alternative_sizes",
  "release_date",
] as const;

export function resolveBloomreachCredentials(overrides: {
  accountId?: string;
  domainKey?: string;
  authKey?: string;
}): { accountId: string; domainKey: string; authKey?: string } {
  return {
    accountId:
      overrides.accountId ||
      window.DUSK?.bloomreachAccountId ||
      import.meta.env.VITE_BLOOMREACH_ACCOUNT_ID ||
      "",
    domainKey:
      overrides.domainKey ||
      window.DUSK?.bloomreachDomainKey ||
      import.meta.env.VITE_BLOOMREACH_DOMAIN_KEY ||
      "",
    // Optional — only the v2 Recommendations API requires it (sent as a header).
    // Omitted entirely when blank so search keeps working without one.
    authKey: overrides.authKey || import.meta.env.VITE_BLOOMREACH_AUTH_KEY || undefined,
  };
}

export function toSdkConfiguration(config: BloomreachConfig): Configuration {
  const account_id = Number(config.accountId);
  if (Number.isNaN(account_id))
    throw new Error(`Invalid Bloomreach account_id: "${config.accountId}"`);
  return {
    account_id,
    domain_key: config.domainKey,
    ...(config.authKey ? { auth_key: config.authKey } : {}),
  };
}
